import { useState } from "react";
import Layout from "@/components/feature/Layout";
import PageHeader from "@/components/feature/PageHeader";
import ProjectCard from "@/components/feature/ProjectCard";
import Reveal from "@/components/feature/Reveal";
import { projects, projectFilters, type ProjectStatus } from "@/mocks/projects";

type FilterValue = ProjectStatus | "todos";

export default function Proyectos() {
  const [filter, setFilter] = useState<FilterValue>("todos");

  const filtered =
    filter === "todos" ? projects : projects.filter((p) => p.status === filter);

  return (
    <Layout>
      <PageHeader
        eyebrow="Proyectos"
        title="Nuestros proyectos"
        subtitle="Espacios diseñados para una nueva forma de vivir."
      />

      <section className="px-4 md:px-8 lg:px-12 py-14 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col gap-10">
          <div className="flex flex-wrap justify-center gap-2">
            <div className="inline-flex items-center gap-1 rounded-full bg-background-100 px-1 py-1">
              {projectFilters.map((f) => (
                <button
                  key={f.value}
                  type="button"
                  onClick={() => setFilter(f.value)}
                  className={`rounded-full px-5 py-2 text-sm font-semibold transition-colors duration-300 whitespace-nowrap ${
                    filter === f.value
                      ? "bg-primary-500 text-background-50 dark:text-foreground-950"
                      : "text-foreground-600 hover:text-foreground-900"
                  }`}
                >
                  {f.label}
                </button>
              ))}
            </div>
          </div>

          {filtered.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {filtered.map((project, index) => (
                <Reveal key={project.id} delay={index * 80}>
                  <ProjectCard project={project} />
                </Reveal>
              ))}
            </div>
          ) : (
            <div className="flex flex-col items-center gap-4 text-center py-16 rounded-lg border border-dashed border-background-300/60">
              <span className="w-16 h-16 flex items-center justify-center rounded-full bg-background-100 text-foreground-300">
                <i className="ri-building-2-line text-3xl" />
              </span>
              <h3 className="font-heading text-2xl text-foreground-800">
                Pronto nuevos proyectos
              </h3>
              <p className="max-w-md text-sm text-foreground-500 leading-relaxed">
                Estamos desarrollando nuevos proyectos en distintas comunas de la Región
                Metropolitana. Vuelve pronto para conocerlos.
              </p>
            </div>
          )}
        </div>
      </section>
    </Layout>
  );
}